import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer.component';
import { HubLogoModule } from '../hub-logo/hub-logo.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { IfCblcDirectiveModule } from '../../directives/if-cblc/if-cblc.module';

@NgModule({
    imports: [
        CommonModule,
        HubLogoModule,
        RouterModule,
        SvgIconModule,
        IfCblcDirectiveModule,
    ],
    exports: [ FooterComponent ],
    declarations: [ FooterComponent ],
})
export class FooterModule {}
